// extracted by mini-css-extract-plugin
export var icon = "_by-3";
export var subtitle = "_by-2";
export var title = "_by-1";
export var value = "_by-0";